// src/pages/customerComponents/ContactForm.js
import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import '../../styles/CustomerSiteStyles/ContactForm.css';

const ContactUs = ({ isInHero = false }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const serviceID  = 'service_ct659js';
    const templateID = 'template_8me0tue';
    const publicKey  = 'WDj2Vkb5uvjrLg-D-';

    const templateParams = {
      from_name:  formData.name,
      from_email: formData.email,
      phone:      formData.phone,
      address:    formData.address,
      message:    formData.message,
    };

    emailjs.send(serviceID, templateID, templateParams, publicKey)
      .then(() => {
        setSubmitted(true);
        setFormData({ name: '', email: '', phone: '', address: '', message: '' });
      }, () => {
        alert('An error occurred while sending your message. Please try again later.');
      });
  };

  const content = submitted ? (
    <div className="contact-form">
      <div className="thank-you-message">
        <div className="thank-you-message__icon">🎉</div>
        <h1>Thank You!</h1>
        <p>Your message has been sent. We'll get back to you shortly.</p>
      </div>
    </div>
  ) : (
    <div className="contact-form">
      <div className="contact-form__eyebrow">Get in Touch</div>
      <h1>Contact Us</h1>
      <p className="contact-form__sub">
        Fill out the form below and a member of our team will reach out within one business day.
      </p>

      <form onSubmit={handleSubmit}>
        <div className="cf-form-row">
          <div className="cf-form-group">
            <label htmlFor="name">Full Name <span style={{ color: '#ffcc00' }}>*</span></label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Jane Smith"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="cf-form-group">
            <label htmlFor="email">Email Address <span style={{ color: '#ffcc00' }}>*</span></label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="jane@example.com"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="cf-form-row">
          <div className="cf-form-group">
            <label htmlFor="phone">Phone Number <span style={{ color: '#ffcc00' }}>*</span></label>
            <input
              type="tel"
              id="phone"
              name="phone"
              placeholder="5550001234"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>
          <div className="cf-form-group">
            <label htmlFor="address">Property Address</label>
            <input
              type="text"
              id="address"
              name="address"
              placeholder="123 Main St, Chicago, IL"
              value={formData.address}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="cf-form-group cf-form-group--full">
          <label htmlFor="message">How Can We Help?</label>
          <textarea
            id="message"
            name="message"
            rows={4}
            placeholder="Tell us about your project or any questions you have…"
            value={formData.message}
            onChange={handleChange}
            required
          />
        </div>

        <button type="submit">Send Message →</button>
      </form>
    </div>
  );

  if (isInHero) {
    return content;
  }

  return (
    <div className="contact-page-wrapper">
      {content}
    </div>
  );
};

export default ContactUs;
